import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'LoadPaginationLazy',
        path: () => path.join(__dirname, './LoadPagination'),
        resolve: () => require.resolveWeak('./LoadPagination'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "LoadPaginationLazy" */ './LoadPagination'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
